var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Restart1Cccopycopy01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_1363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.858 0.161133L0.290039 2.67513L4.10004 6.48513C1.89104 9.23913 0.526039 12.6951 0.526039 16.5001C0.526039 25.3901 7.73304 32.6021 16.628 32.6021C25.523 32.6021 32.73 25.3891 32.73 16.4991C32.73 9.83213 28.685 4.09813 22.912 1.65413V5.54213C26.717 7.72713 29.274 11.8011 29.274 16.4991C29.274 23.4901 23.619 29.1451 16.628 29.1451C9.63704 29.1451 3.98204 23.4891 3.98204 16.4991C3.98204 13.6421 4.93404 11.0351 6.53504 8.91913L10.345 12.7291L12.858 0.161133Z",
    fill: "#807566"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_1363"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Restart1Cccopycopy01);
export default __webpack_public_path__ + "static/media/icons8-restart 1cc copy copy-01.83aabfffe9fd017be2a829718b8208c1.svg";
export { ForwardRef as ReactComponent };